import { styled } from '@raskrask-dk/rr-components'

export const Overlapper = styled('div', {
    br: '$2',
})

export const StyledPageTemplate = styled('div', {
    display: 'grid',
    gap: '$3',
})
